<template>
  <div :id="`id-${id}-modal-item-contents`" class="modal-item " :class="{'hidden': !isShow, 'open': isShow}">
    <div :id="`id-${id}-modal-item-handle`" class="top flex" >
      <h5 class="p-4">{{ name }}</h5>
      <div class="btn-close ml-auto"
           style="padding: 4px;"
           @click="handleClickCloseModal">
        <feather-icon icon="XIcon" stroke-width="2" />
      </div>
    </div>
    <div class="container">
      <div class="container-body">
        <slot />
      </div>
    </div>
    <div class="main-popup-footer">
      <slot name="footer">
        <label v-if="`${skipDate}` === '1'" class="cursor-pointer flex items-center"><vs-checkbox @change="(event) => handleChangeWatch(event.target.checked, 1)"/>오늘 하루동안 보지 않기</label>
        <label v-else-if="`${skipDate}` === '7'" class="cursor-pointer flex items-center"><vs-checkbox @change="(event) => handleChangeWatch(event.target.checked, 7)"/>7일간 보지 않기</label>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModalItem",
  props: {
    id: [String, Number],
    name: String, //name: boardName, title: post 의 title
    /**
     * isShow
     * 팝업 표시 여부
     */
    isShow: Boolean,
    /**
     * skipDate
     * 팝업을 다시 보지 않기 설정 (1: 하루, 7: 일주일)
     */
    skipDate: {
      type: [Number, String],
      default: 1
    }
  },
  watch: {
    isShow (value) {
      if (value) {
        this.dragElement(document.getElementById(`id-${this.id}-modal-item-contents`), document.getElementById(`id-${this.id}-modal-item-handle`));
      }
    },
  },
  mounted() {
    const element = this.element
    const imageList = this.elementImgs

    //    팝업이 중앙에 노출 하도록 처리
    if (imageList.length > 0) {
      //  이미지가 있는 경우
      let count = 0;
      for (const img of imageList) {
        img.addEventListener("load", () => {
          count++;
          element.style.transform = `translate(-${element.offsetWidth/2}px, -${element.offsetHeight/2}px)`
          if (imageList.length === count) {
            this.dragElement(document.getElementById(`id-${this.id}-modal-item-contents`), document.getElementById(`id-${this.id}-modal-item-handle`));
          }
        })
      }
    } else {
      //  이미지가 없는 경우
      element.style.transform = `translate(-${element.offsetWidth/2}px, -${element.offsetHeight/2}px)`
      this.dragElement(document.getElementById(`id-${this.id}-modal-item-contents`), document.getElementById(`id-${this.id}-modal-item-handle`));
    }

  },
  computed: {
    element () {
      return document.getElementById(`id-${this.id}-modal-item-contents`)
    },
    elementImgs () {
      try {
        return this.element.getElementsByClassName("container-body")[0].getElementsByTagName("img")
      } catch (e) {
      }

      return []
    }
  },
  methods: {
    close () {
      this.$store.commit("menu/CLOSE_MODAL", this.id)
    },
    dragElement(targetElmnt, handleElmnt) {
      console.log("this.element.offsetWidth", this.element.offsetWidth, this.element.offsetHeight )
      const elementID = this.id
      let pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0, targetX = -1*this.element.offsetWidth/2, targetY = -1*this.element.offsetHeight/2;
      handleElmnt.onmousedown = dragMouseDown;

      function dragMouseDown(e) {
        e = e || window.event;
        e.preventDefault();
        pos3 = e.clientX;
        pos4 = e.clientY;
        document.onmouseup = closeDragElement;
        document.onmousemove = elementDrag;
      }

      function elementDrag(e) {
        e = e || window.event;
        e.preventDefault();
        pos1 = e.clientX - pos3;
        pos2 = e.clientY - pos4;
        pos3 = e.clientX;
        pos4 = e.clientY;
        targetX += pos1;
        targetY += pos2;

        targetElmnt.style.transform = `translate(${targetX}px, ${targetY}px)`
      }

      function closeDragElement() {
        document.onmouseup = null;
        document.onmousemove = null;
      }
    },

    handleChangeWatch (checked, skipDate) {
      if (checked) {
        this.$store.commit("menu/DELETE_MODAL_DAY", {id:this.id, day:skipDate})
      } else {
        this.$store.commit("menu/REVERT_MODAL", this.id)
      }
    },
    handleClickCloseModal () { this.close() },
  }
}
</script>

<style lang="scss" scoped>
.modal-item {
  position: absolute;
  top: 50%;
  left: 50%;
  min-width: 240px;  max-width: 90%;
  min-height: 320px; max-height: 600px;
  box-shadow: 0px 2px 8px 0px #00000024;


  .top {
    cursor: move;
    border-top-left-radius: 0.5rem;
    border-top-right-radius: 0.5rem;

    align-items: center;
    line-height: 1.2rem;
  }
  .container {
    padding-bottom: 50px;
  }
  .container-body {
    max-height: calc(80vh - 50px - 50px);
    overflow: auto;
  }
}
.modal-item {
  width: auto;
  max-height: 80vh;
  border-radius: 0.5rem;
  background-color: #fff;
  z-index: 51000;

  .tools {
    display: flex;
    border-top: 1px solid #999;

    .btn:first-child {
      border-bottom-left-radius: 0.5rem;
    }
    .btn:last-child {
      border-bottom-right-radius: 0.5rem;
    }
  }

  .btn-close {
    background: #fff;
    color: #979797;
    cursor: pointer;
    box-shadow: 0px 5px 20px 0px #00000040;
    border-radius: 8px;
    transform: translate(30%, -40%);
  }
  .btn-close:active {
    transform: translate(20%, -30%);
  }

  .main-popup-footer {
    padding: 1rem 0.8rem;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;

    display: inline-flex;
  }
}
</style>
